var _path, _path2, _path3, _path4, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    stroke: "#1E073A",
    fill: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,25H6   c-2.761,0-5-2.239-5-5v0c0-2.761,2.239-5,5-5h1V25z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,25h-1V15h1   c2.761,0,5,2.239,5,5v0C31,22.761,28.761,25,26,25z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,15v-3   C5,5.925,9.925,1,16,1h0c6.075,0,11,4.925,11,11v3",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,25v4   c0,1.105-0.895,2-2,2h-3",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    x2: 20,
    y1: 31,
    y2: 31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fd16f2f7d1ad0e81ca410f2ab761f8f0.svg";
export { ForwardRef as ReactComponent };